import Panel from "Components/Panel/Panel";
import React, { useEffect, useState } from "react";
import RightArrow from "../../../../../Components/SideBar/assets/icons/right-arrow.png"
import OptionsPanel from "Components/OptionsPanel/OptionsPanel";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import BenefitsDayEmployeeList from "./BenefitDayPanels/BenefitsDayEmployeeList";

const BenefitsDayPanel = ({
    costDayIdSelecteds,
    onUpdateCostDayIdSelecteds,
    dsItem,
    dsMonth,
    currentMonth,
    showNewBenefitMonthPanel,
    onUpdateInsertBenefit,
    handleClose,
    getButtonToShowSubtitles,
    panelListCostDay,
    updatePanelCostSpreadsheet,
    onUpdatePanelCostSpreadsheet,
    onUpdateIdEmployee,
    onUpdateReloadSalaryBenefitsCost
}) => {
    const [dsEmployee, setDsEmployee] = useState(null)
    const [updating, setUpdating] = useState(false)

    const costDayStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '95%',
        zIndex: '0',
        overflow: 'hidden'
    }

    useEffect(() => {
        const fetchData = async () => {
            const parameters = {
                id: costDayIdSelecteds[0]
            }
            const benefitsListEmployee = await ExecuteAxios.api('get', '/benefits-month/employee-name-of-benefit-month/', { params: parameters });
            if (benefitsListEmployee) {
                setDsEmployee(benefitsListEmployee.employeeName)
                onUpdateIdEmployee(benefitsListEmployee.id)
            }
        }
        if (!costDayIdSelecteds || costDayIdSelecteds.length != 1) {
            setDsEmployee(null)
        } else {
            fetchData();
        }
    }, [costDayIdSelecteds])

    function getEmployeeBenefitsPanel() {
        if (costDayIdSelecteds && costDayIdSelecteds.length === 1) {
            return (
                {
                    label: dsEmployee || 'Selecione um registro',
                    component: (
                        getBenefitDayPanel()
                    )
                }
            )
        } else {
            return (
                {
                    label: dsEmployee || 'Selecione um registro',
                    component: (
                        null
                    )
                }
            )
        }
    }

    function getBenefitDayPanel() {
        return (
            <BenefitsDayEmployeeList
                costDayIdSelecteds={costDayIdSelecteds}
                updating={updating}
                currentMonth={currentMonth}
                showNewBenefitMonthPanel={showNewBenefitMonthPanel}
                onUpdateInsertBenefit={onUpdateInsertBenefit}
                updatePanelCostSpreadsheet={updatePanelCostSpreadsheet}
                onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                onUpdating={setUpdating}
                onUpdateReloadSalaryBenefitsCost={onUpdateReloadSalaryBenefitsCost}
            />
        )
    }

    return (
        <Panel titlePage={dsMonth + ' - ' + dsItem}
            style={costDayStyle}
            canViewCRUD={true}
            componentRightButtons={(updating || showNewBenefitMonthPanel) ? null :
                <button
                    style={{
                        backgroundImage: `url(${RightArrow})`,
                        backgroundSize: '30px 30px',
                        width: '35px',
                        height: '35px',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        alignItems: 'center'
                    }}
                    onClick={handleClose}
                />
            }
            subtitlesPanelBottom={getButtonToShowSubtitles()}
        >
            <OptionsPanel
                options={[
                    {
                        label: 'Benefício',
                        component: panelListCostDay,
                    },
                    getEmployeeBenefitsPanel()
                ]}
                heigthLess={'60px'}
                mainPanelStyle={{ height: 'calc(100% - 56px)' }}
            />
        </Panel>
    )
}

export default BenefitsDayPanel;